/** Currency key for home-currency totals (invoice amount × exchange rate) */
export const PAYMENT_FORECAST_HOME_KEY = `HOME`;
//# sourceMappingURL=metrics.js.map